import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import AdminDashboard from './components/AdminDashboard';
import CaseDocuments from './components/CaseDocuments';
import TemplateManagement from './components/TemplateManagement';
import TemplateEditor from './components/TemplateEditor';
import MyTemplates from './components/MyTemplates';
import RecentActivity from './components/RecentActivity';
// import TemplateAssignment from './components/TemplateAssignment';
import LoginPage from './components/LoginPage';
import Unauthorized from './components/Unauthorized';
import Header from './components/Header';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import { ThemeProvider } from './context/ThemeContext';
import { DataSourceProvider } from './context/DataSourceContext';
import { TitleProvider } from './context/TitleContext';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { DemoModeProvider } from './context/DemoModeContext';
import ToastContainer from './components/ToastContainer';
import './index.css';
import NotFoundPage from './components/NotFoundPage';
import NewDocumentRequest from './components/NewDocumentRequest';
import SendDocumentRequest from './components/SendDocumentRequest';
// Admin pages
import { AdminAnalytics } from './components/admin/pages/AdminAnalytics';
import { OrganizationsList } from './components/admin/pages/OrganizationsList';
import { OrganizationDetail } from './components/admin/pages/OrganizationDetail';
import { UsersList } from './components/admin/pages/UsersList';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <DataSourceProvider>
          <TitleProvider>
            <AuthProvider>
              <DemoModeProvider>
                <ToastProvider>
                  <Router>
                    <div className="min-h-screen flex flex-col bg-white dark:bg-gray-900 transition-colors duration-200">
                      <Header />
                      <main className="container mx-auto px-4 py-6 flex-grow mt-2">
                        <Routes>
                          <Route path="/login" element={<LoginPage />} />
                          <Route path="/unauthorized" element={<Unauthorized />} />
                      
                      <Route path="/" element={
                        <ProtectedRoute>
                          <AdminDashboard />
                        </ProtectedRoute>
                      } />
                      
                      {/* Admin Routes */}
                      <Route path="/admin/analytics" element={
                        <ProtectedRoute>
                          <AdminAnalytics />
                        </ProtectedRoute>
                      } />
                      
                      <Route path="/admin/organizations" element={
                        <ProtectedRoute>
                          <OrganizationsList />
                        </ProtectedRoute>
                      } />
                      
                      <Route path="/admin/organizations/:id" element={
                        <ProtectedRoute>
                          <OrganizationDetail />
                        </ProtectedRoute>
                      } />
                      
                      <Route path="/admin/users" element={
                        <ProtectedRoute>
                          <UsersList />
                        </ProtectedRoute>
                      } />
                      
                      <Route path="*" element={<NotFoundPage />} />

                      <Route path="/case/:caseId" element={
                        <ProtectedRoute>
                          <CaseDocuments />
                        </ProtectedRoute>
                      } />


                      <Route path="/requests/new" element={
                        <ProtectedRoute requiredPermission="new_request">
                            <NewDocumentRequest />
                        </ProtectedRoute>
                      } />
                      
                      <Route path="/templates" element={
                        <ProtectedRoute requiredPermission="manage_templates">
                          <TemplateManagement />
                        </ProtectedRoute>
                      } />
                      
                      <Route path="/my-templates" element={
                        <ProtectedRoute requiredPermission="new_request">
                          <MyTemplates />
                        </ProtectedRoute>
                      } />
                      
                      <Route path="/recent-activity" element={
                        <ProtectedRoute requiredPermission="new_request">
                          <RecentActivity />
                        </ProtectedRoute>
                      } />
                      
                      <Route path="/templates/new" element={
                        <ProtectedRoute requiredPermission="new_request">
                          <TemplateEditor />
                        </ProtectedRoute>
                      } />
                      
                      <Route path="/templates/:templateId/send" element={
                        <ProtectedRoute requiredPermission="new_request">
                          <SendDocumentRequest />
                        </ProtectedRoute>
                      } />
                      
                      <Route path="/templates/:templateId/edit" element={
                        <ProtectedRoute requiredPermission="new_request">
                          <TemplateEditor />
                        </ProtectedRoute>
                      } />
                      {/* 
                      <Route path="/assign" element={
                        <ProtectedRoute requiredPermission="assign_templates">
                          {/* <TemplateAssignment /> */}
                          {/* <button className="bg-blue-500 text-white px-4 py-2 rounded">
                            Assign Template</button>
                        </ProtectedRoute> */}
                      {/* } /> */}

                </Routes>
              </main>
              <Footer />
              <ToastContainer />
            </div>
          </Router>
        </ToastProvider>
      </DemoModeProvider>
    </AuthProvider>
  </TitleProvider>
</DataSourceProvider>
</ThemeProvider>
</I18nextProvider>
  );
}

export default App;
